import React from 'react'
import {Card, ListGroup} from 'react-bootstrap'
import {Link} from 'react-router-dom'
import './style.css'

export default function cardspopup() {
    return (
        <Card className="toko-nav head-nav">
        <Card.Body>
            <img src="asset/dashboard/icons/user.svg" alt="user" />
            Muhammad Rifqi Mubarak
            <div className="group">
                <div className="poin">
                    Poin 0
                </div>
                <div className="kupon">
                    Kupon 5
                </div>
            </div>
        </Card.Body>
            <ListGroup variant="flush">
                {
                    Items.map((data, i) => {
                        return (
                            <ListGroup.Item>
                                <Link key={i} to={data.link}>
                                <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d={data.icon} stroke="#858585" stroke-linecap="round"/>
                                </svg>
                                    {data.name}
                                </Link>
                            </ListGroup.Item>
                        )
                    })
                }
            </ListGroup>   
        </Card>
    )
}

const Items = [
    {name:"Profile", link:"/profile"},
    {name:"Transaksi", link:"/transaksi"},
    {name:"Belajar Menjadi Reseller", link:"/menjadi_reseller"},
    {name:"Keluar", link:"/keluar", icon:"M6 1L1 6.16129L5.6875 11"}
]
